"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.poetryAdd = void 0;
const pathLib = require("path");
const debugLib = require("debug");
const poetryFix = require("@snyk/fix-poetry");
const validate_required_data_1 = require("../../validate-required-data");
const attempted_changes_summary_1 = require("../../attempted-changes-summary");
const command_failed_to_run_error_1 = require("../../../../../lib/errors/command-failed-to-run-error");
const no_fixes_applied_1 = require("../../../../../lib/errors/no-fixes-applied");
const debug = debugLib('snyk-fix:python:poetryAdd');
async function poetryAdd(entity, options, upgrades, dev) {
    var _a;
    const changes = [];
    let poetryCommand;
    const { remediation, targetFile } = (0, validate_required_data_1.validateRequiredData)(entity);
    try {
        const targetFilePath = pathLib.resolve(entity.workspace.path, targetFile);
        const { dir } = pathLib.parse(targetFilePath);
        if (!options.dryRun && upgrades.length) {
            const { stderr, stdout, command, exitCode } = await poetryFix.poetryAdd(dir, upgrades, {
                dev,
                python: (_a = entity.options.command) !== null && _a !== void 0 ? _a : undefined,
            });
            debug('`poetry add` returned:', { stderr, stdout, command });
            if (exitCode !== 0) {
                poetryCommand = command;
                throwPoetryError(stderr, stdout, command);
            }
        }
        changes.push(...(0, attempted_changes_summary_1.generateSuccessfulChanges)(upgrades, remediation.pin));
    }
    catch (error) {
        changes.push(...(0, attempted_changes_summary_1.generateFailedChanges)(upgrades, remediation.pin, error, poetryCommand));
    }
    return changes;
}
exports.poetryAdd = poetryAdd;
function throwPoetryError(stderr, stdout, command) {
    const ALREADY_UP_TO_DATE = 'No dependencies to install or update';
    const INCOMPATIBLE_PYTHON = new RegExp(/Python requirement (.*) is not compatible/g, 'gm');
    const SOLVER_PROBLEM = /SolverProblemError(.* version solving failed)/gms;
    const incompatiblePythonError = INCOMPATIBLE_PYTHON.exec(stderr) || SOLVER_PROBLEM.exec(stdout);
    if (incompatiblePythonError) {
        throw new command_failed_to_run_error_1.CommandFailedError(`The current project's Python requirement ${incompatiblePythonError[1]} is not compatible with some of the required packages`, command);
    }
    const solverProblemError = SOLVER_PROBLEM.exec(stderr) || SOLVER_PROBLEM.exec(stdout);
    if (solverProblemError) {
        throw new command_failed_to_run_error_1.CommandFailedError(solverProblemError[0].trim(), command);
    }
    if (stderr.includes(ALREADY_UP_TO_DATE) ||
        stdout.includes(ALREADY_UP_TO_DATE)) {
        throw new command_failed_to_run_error_1.CommandFailedError('No dependencies could be updated as they seem to be at the correct versions. Make sure installed dependencies in the environment match those in the lockfile by running `poetry update`', command);
    }
    throw new no_fixes_applied_1.NoFixesCouldBeAppliedError();
}
//# sourceMappingURL=poetry-add.js.map